import { render, staticRenderFns } from "./TeacherDashboard.vue?vue&type=template&id=9dd89b6a&"
import script from "./TeacherDashboard.vue?vue&type=script&lang=js&"
export * from "./TeacherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports